import { Snippet } from '../../dataModels';

export const tableSnippet: Snippet = {
  shiftsummaryDisplyId: '12601885-bbf3-ec11-9147-005056b29cce',
  name: 'TABLE ACTIVITIES',
  displayName: 'TABLE ACTIVITIES',
  description: null,
  order: 5,
  type: 'Table',
  enableEdit: 'True',
  enableComment: true,
  canAddDeleteRows: 'True',
  maxRows: 20,
  isEdited: false,
  configuration: {
    rowTitleKey: 'LimitName',
    columnCount: 8,
    columns: [
      {
        id: 1,
        name: 'LimitName',
        displayName: 'LimitName',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 2,
        name: 'StartTime',
        displayName: 'StartTime',
        controlType: 'DateTime',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 3,
        name: 'EndTime',
        displayName: 'EndTime',
        controlType: 'DateTime',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 4,
        name: 'TagHighValue',
        displayName: 'TagHighValue',
        controlType: 'Numeric',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 5,
        name: 'IsDigital',
        displayName: 'IsDigital',
        controlType: 'Checkbox',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 6,
        name: 'ElapsedCycles',
        displayName: 'ElapsedCycles',
        controlType: 'Numeric',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 7,
        name: 'Key',
        displayName: 'Key',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'False',
      },
      {
        id: 8,
        name: 'Comments',
        displayName: 'Comments',
        controlType: 'Text',
        controlValues: null,
        visible: 'True',
      },
    ],
    matrixCells: null,
  },
  data: [
    {
      rollupDetails: null,
      rowCount: 3,
      rowData: [
        {
          LimitName: 'OP_Mon_Limit',
          StartTime: '2/23/2021 1:52:00 AM',
          EndTime: '2/23/2021 1:52:00 AM',
          TagHighValue: '50.00000',
          IsDigital: 'False',
          ElapsedCycles: '',
          Key: '[{"KeyValue":"OP_Mon_Limit"},{"KeyValue":"2/23/2021 1:52:00 AM"}]',
          Comments: '',
        },
        {
          LimitName: 'OP_INS_LIMIT',
          StartTime: '12/30/2020 6:05:00 AM',
          EndTime: '12/30/2020 6:10:00 AM',
          TagHighValue: '50.00000',
          IsDigital: 'False',
          ElapsedCycles: '1',
          Key: '[{"KeyValue":"OP_INS_LIMIT"},{"KeyValue":"12/30/2020 6:05:00 AM"}]',
          Comments: '',
        },
        {
          LimitName: 'ALARM_ERO',
          StartTime: '5/12/2020 3:15:00 PM',
          EndTime: '6/18/2020 2:05:00 AM',
          TagHighValue: '-1.00000',
          IsDigital: 'False',
          ElapsedCycles: '10498',
          Key: '[{"KeyValue":"ALARM_ERO"},{"KeyValue":"5/12/2020 3:15:00 PM"}]',
          Comments: '',
        },
      ],
    },
  ],
  count: 0,
  groupSnippets: null,
};
